import React, { useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../App';
import './Auth.css';

export default function Login() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { token } = useAuth();
  const error = params.get('error');

  useEffect(() => {
    if (token) navigate('/shop');
  }, [token, navigate]);

  const errorMessages = {
    no_code: 'La connexion Discord a échoué. Veuillez réessayer.',
    not_member: 'Vous n\'êtes pas membre du serveur Discord NexaRP. Rejoignez le serveur pour accéder.',
    discord_error: 'Une erreur est survenue lors de la connexion Discord. Veuillez réessayer.',
    no_license: null,
    no_character: null,
  };

  const msg = error ? errorMessages[error] : null;

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/logo.png" alt="FastBox" className="auth-logo-img" onError={e => { e.target.style.display = 'none'; }} />
          <span className="auth-logo-text">Fast Box</span>
        </div>

        {error && msg ? (
          <>
            <div className="auth-error-icon">
              <i className="fa-solid fa-circle-exclamation" />
            </div>
            <h2 className="auth-title">Accès refusé</h2>
            <p className="auth-desc error-text">{msg}</p>
            <Link to="/" className="btn-primary auth-btn">
              <i className="fa-solid fa-arrow-left" /> Retour à l'accueil
            </Link>
          </>
        ) : (
          <>
            <h2 className="auth-title">Se connecter</h2>
            <p className="auth-desc">
              Connectez-vous avec votre compte Discord pour accéder à la boutique FastBox.
            </p>
            <a href="/api/auth/discord" className="btn-discord auth-btn" style={{ justifyContent: 'center' }}>
              <i className="fa-brands fa-discord" /> Connexion avec Discord
            </a>
            <div className="auth-divider">ou</div>
            <Link to="/" className="btn-secondary auth-btn" style={{ justifyContent: 'center' }}>
              <i className="fa-solid fa-arrow-left" /> Retour à l'accueil
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
